// Lưới an toàn cho lỗi tải chunk sau khi deploy phiên bản mới.
//
// Khi build mới được deploy, các file chunk (React.lazy) đổi hash. Một tab đang
// mở bản cũ nếu điều hướng tới route lazy mà chunk cũ đã bị thay thế sẽ nhận:
//   - "ChunkLoadError" / "Loading chunk ... failed", hoặc
//   - "Unexpected token '<'" (server trả index.html cho file .js không còn tồn tại).
//
// Xử lý: reload trang đúng 1 lần để lấy index.html + bundle mới. Dùng
// sessionStorage để chống lặp vô hạn (nếu reload xong vẫn lỗi -> dừng, tránh loop).

const RELOAD_FLAG_KEY = "chunk-reload-at";
const RELOAD_COOLDOWN_MS = 10_000;

const CHUNK_ERROR_PATTERNS = [
  "ChunkLoadError",
  "Loading chunk",
  "Loading CSS chunk",
  "error loading dynamically imported module",
  "Failed to fetch dynamically imported module",
  "Unexpected token '<'",
  "Unexpected token <",
];

function isChunkLoadError(message?: string): boolean {
  if (!message) return false;
  return CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern));
}

function reloadOnce(): void {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_FLAG_KEY) || 0);
    if (Date.now() - last < RELOAD_COOLDOWN_MS) {
      // Vừa reload mà vẫn lỗi -> không reload nữa để tránh loop.
      return;
    }
    sessionStorage.setItem(RELOAD_FLAG_KEY, String(Date.now()));
  } catch {
    // sessionStorage không khả dụng -> vẫn reload (chấp nhận rủi ro loop hiếm gặp).
  }
  window.location.reload();
}

export function registerChunkReload(): void {
  // Lỗi đồng bộ khi tải script/module.
  window.addEventListener(
    "error",
    (event) => {
      const message =
        (event as ErrorEvent)?.message || (event?.error && event.error.message);
      if (isChunkLoadError(message)) {
        reloadOnce();
      }
    },
    true
  );

  // Lỗi từ dynamic import bị reject (React.lazy).
  window.addEventListener("unhandledrejection", (event) => {
    const reason: any = event?.reason;
    const message =
      typeof reason === "string" ? reason : reason?.message || reason?.name;
    if (isChunkLoadError(message)) {
      reloadOnce();
    }
  });
}